import { render, staticRenderFns } from "./system_customers.vue?vue&type=template&id=4160beed&scoped=true&"
import script from "./system_customers.vue?vue&type=script&lang=js&"
export * from "./system_customers.vue?vue&type=script&lang=js&"
import style0 from "./system_customers.vue?vue&type=style&index=0&id=4160beed&prod&lang=css&"
import style1 from "./system_customers.vue?vue&type=style&index=1&id=4160beed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160beed",
  null
  
)

export default component.exports